import type { ChangeDrawLayers, ChangeMapLicensePlate, ChangeMapRef, ChangeMapTraffic, ChangeMapType, SetOpenMapPopup, SetZoomLevel, ShutdownMap } from './actions';
import { MapActionNames } from './actionTypes';
import type { MapEntityTypes } from './types';
import type L from 'leaflet';

import type { MapType, UUID } from '@cobliteam/common-types';

export const setOpenMapPopup = (entity?: MapEntityTypes, id?: UUID): SetOpenMapPopup => ({
  type: MapActionNames.SET_OPEN_POPUP,
  payload: { entity, id },
});

export const setZoomLevel = (zoomLevel: number): SetZoomLevel => ({
  type: MapActionNames.SET_ZOOM_LEVEL,
  payload: zoomLevel,
});

export const shutdownMap = (): ShutdownMap => ({
  type: MapActionNames.SHUTDOWN_MAP,
});

export const changeMapType = (mapType: MapType): ChangeMapType => {
  return {
    type: MapActionNames.CHANGE_MAP_TYPE,
    payload: mapType,
  };
};

export const changeMapTraffic = (traffic: boolean): ChangeMapTraffic => {
  return {
    type: MapActionNames.CHANGE_MAP_TRAFFIC,
    payload: traffic,
  };
};

export const changeMapLicensePlate = (licensePlate: boolean): ChangeMapLicensePlate => {
  return {
    type: MapActionNames.CHANGE_MAP_LICENSE_PLATE,
    payload: licensePlate,
  };
};

export const changeMapRef = (mapRef: any): ChangeMapRef => {
  return {
    type: MapActionNames.CHANGE_MAP_REF,
    payload: mapRef,
  };
};

export const changeDrawLayers = (drawLayers: L.Layer[]): ChangeDrawLayers => {
  return {
    type: MapActionNames.CHANGE_DRAW_LAYERS,
    payload: drawLayers,
  };
};
